<template>
	<div class="leftres">
		<!-- <div> -->
		<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
			<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
				<Commondropdownlist ref="wareref" :key="index" :options="item.options" :minrigth="item.minrigth"
					:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
					:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
					:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types"
					:inputtype="item.inputtype" :width="item.width">
				</Commondropdownlist>
			</div>
			<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
				<CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
					@reset="reset">
				</CommonBtngroup>
			</div>
			<div style="height:10px;">
			</div>
		</div>
		<div class="TableBox"
			style="margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);  background-color: #FFFFFF;display: initial;">
			<Inboundlistcenter :loading="false" @Expost="Expost" @onRowClick="onRowClick" :tableData="tableData"
				:total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
			</Inboundlistcenter>
		</div>
		<div class="TableBox"
			style="margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
			<Inboundlistbottom :tableDataUnique="tableDataUnique" :tableDataDetail="tableDataDetail" :asnmid="asnmid">
			</Inboundlistbottom>
		</div>
		<!-- </div> -->
	</div>
</template>

<script>
	import Inboundlist from '../../components/Inboundlist.vue'
	import Inboundlistcenter from './components/Inboundlist-center.vue'
	import Inboundlistbottom from './components/Inboundlist-bottom.vue'
	import Commondropdownlist from '../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../components/commongroup.vue'
	import utils from '../../common/utils'
	import {
		AsnList,
		ASNVoucherType,
		Status,
		InventoryClassList,
		AsnExpost,
		CusType,
		AsnUnique,
		AsnDetail,
		GetProvince
	} from '@/api/home'
	export default {
		components: {
			Inboundlist,
			Inboundlistcenter,
			Inboundlistbottom,
			Commondropdownlist,
			CommonBtngroup
		},
		data: function() {
			return {
				asnmid: '',
				form: {
					cusGrade: '',
					vouCode: '',
					cusName: '',
					createTime1: '',
					createTime2: '',
					invClass: '',
					status: null,
					voucherType: '',
					VerifyTime1: '',
					VerifyTime2: '',
					InvAddCode: '',
					InvName: '',
					Batch: '',
					ProvinceID: '',
					SalesMan: ''
				},
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '经销商单据号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					// {
					//   inputdata: '',
					//   title: '经销商名称',
					//   fontSize: '14px',
					//   color: '#333333',
					//   placeholder: '请输入',
					//   types: 'text',
					//   inputtype: 'selectautocompletes',
					//   width: '170px',
					//   lablewith: '95px',
					//   options: []
					// },
					{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: "",
						title: "入库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						//   lablewith: '95px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						lablewith: '95px',
						options: []
					},
					{
						inputdata: null,
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '95px',
						options: []
					},


					{
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '95px',
						options: [

						]
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						//   lablewith: '95px'
					},
					{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '经销商类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [{
							value: '一级经销商',
							key: '1'
						}, {
							value: '二级经销商',
							key: '2'
						}],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '省份',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: [

						],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '销售',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					}
				],
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				tableDataUnique: [],
				tableDataDetail: []

			}
		},
		mounted() {
			this.onchage = 0
			//this.asnList()
			this.$refs.wareref[2].startTime = this.$utils.getFYearDate();
			this.$message.warning("请填写搜索条件！");
			this.aSNVoucherType()
			this.status()
			this.inventoryClassList()
			this.getProvince();
		},
		methods: {
			//省份列表
			async getProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				console.log(data, '省');
				if (code == 0) {
					this.formdata[11].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[11].options.push(obj)
					})

				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			},
			// 唯一码明细
			async asnUnique() {
				let {
					data,
					code
				} = await AsnUnique({
					asnmid: this.asnmid
				})
				if (code == 0) {
					this.tableDataUnique = data
				}
			},
			// 明细
			async asnDetail() {
				let {
					data,
					code
				} = await AsnDetail({
					asnmid: this.asnmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			// 导出接口
			async asnExpost() {
				let resexprot = await AsnExpost({
					cusGrade: this.form.cusGrade,
					vouCode: this.form.vouCode,
					cusName: this.form.cusName,
					createTime1: this.form.createTime1,
					createTime2: this.form.createTime2,
					invClass: this.form.invClass,
					status: this.form.status != null || this.form.status == '' ? this.form.status : null,
					voucherType: this.form.voucherType,
					VerifyTime1: this.form.VerifyTime1,
					VerifyTime2: this.form.VerifyTime2,
					InvAddCode: this.form.InvAddCode,
					InvName: this.form.InvName,
					Batch: this.form.Batch,
					ProvinceIDs: this.form.ProvinceID,
					SalesMan: this.form.SalesMan,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {

					// 切割出文件名
					// const fileNameEncode = resexprot.headers.get('content-disposition').split('filename=')[1]
					// // 解码
					// const fileName = decodeURIComponent(fileNameEncode)
					//console.log(resexprot.headers);
					// //console.log('fileName', fileName)

					utils.downloadFile(resexprot.data, "入库单导出", "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}

			},
			// 导出
			Expost() {
				this.asnExpost()
			},
			onRowClick(val) {
				this.asnmid = val.ASNMID
				this.asnUnique()
				this.asnDetail()
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[3].options.push(obj)
					})
				}
			},
			// 单据类型下拉
			async aSNVoucherType() {
				let {
					code,
					data
				} = await ASNVoucherType({})
				if (code == 0) {
					this.formdata[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[5].options.push(obj)
					})

				}

			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.formdata[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[4].options.push(obj)
					})

				}

			},
			// 列表
			async asnList() {
				// console.log(this.form.status,'this.form.status');
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await AsnList({
					cusGrade: this.form.cusGrade,
					vouCode: this.form.vouCode,
					cusName: this.form.cusName,
					createTime1: this.form.createTime1,
					createTime2: this.form.createTime2,
					invClass: this.form.invClass,
					status: this.form.status != null || this.form.status == '' ? this.form.status : null,
					voucherType: this.form.voucherType,
					VerifyTime1: this.form.VerifyTime1,
					VerifyTime2: this.form.VerifyTime2,
					InvAddCode: this.form.InvAddCode,
					InvName: this.form.InvName,
					Batch: this.form.Batch,
					ProvinceIDs: this.form.ProvinceID,
					SalesMan: this.form.SalesMan,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						loading.close();
						this.tableData = data.data
					}
				}
			},
			async remoteMethodtows(query) {
				this.loading = true
				let {
					code,
					data
				} = await CusType({
					// hpName: query
				})
				if (code == 0) {
					this.formdata[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusType
						}
						this.formdata[1].options.push(obj)
					})
					this.loading = false
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.asnList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.asnList()
			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			// 搜索
			select() {
				this.pageindex = 1
				console.log(this.$refs.wareref, 'this.$refs.wareref');
				this.form.vouCode = this.$refs.wareref[0].modelvalue
				this.form.cusName = this.$refs.wareref[1].modelvalue
				this.form.createTime1 = this.$refs.wareref[2].startTime
				this.form.createTime2 = this.$refs.wareref[2].endTime
				this.form.invClass = this.$refs.wareref[3].modelvalue ? this.$refs.wareref[3].modelvalue.join(',') : '';
				this.form.status = this.$refs.wareref[4].modelvalue
				this.form.voucherType = this.$refs.wareref[5].modelvalue
				this.form.VerifyTime1 = this.$refs.wareref[6].startTime
				this.form.VerifyTime2 = this.$refs.wareref[6].endTime
				this.form.InvAddCode = this.$refs.wareref[7].modelvalue
				this.form.InvName = this.$refs.wareref[8].modelvalue
				this.form.Batch = this.$refs.wareref[9].modelvalue
				this.form.cusGrade = this.$refs.wareref[10].modelvalue
				this.form.ProvinceID = this.$refs.wareref[11].modelvalue ? this.$refs.wareref[11].modelvalue.join(',') :
					'';
				this.form.SalesMan = this.$refs.wareref[12].modelvalue
				this.asnList()

			},
			selectTow() {
				this.form.vouCode = this.$refs.wareref[0].modelvalue
				this.form.cusName = this.$refs.wareref[1].modelvalue
				this.asnList()
			},
			// 重置
			reset() {
				for (let index in this.$refs.wareref) {
					if (index == 2 || index == 6) {
						this.$refs.wareref[index].startTime = ''
						this.$refs.wareref[index].endTime = ''
					} else {
						this.$refs.wareref[index].modelvalue = ''
					}
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.avcite {
		border-left: 4px solid #e71d43;
		background-color: #fce8ec;
		color: #e71d43;
	}

	.leftres {
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.inputtop {
		width: 980px;
		height: 135px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 45px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>